import moment from 'moment';
import {userStore} from '../stores/user.store';
import {history} from 'fn-common-ui';
import {apiService} from './api.service';
import {saveAs} from 'file-saver';
import config from 'config';
const base = config.apiBase;

class UtilsService {

  constructor() {
    this.totalBlobSize = 0;
  }

  triggerCustomEvent(name, detail) {
    let event = new CustomEvent(name, { detail });
    window.dispatchEvent(event);
  }

  tagLinkItem(title, linkName, linkDestinationUrl) {
    const params = {
      'page.location.url': 'training.firstnet.att.com',
      'page.pageInfo.friendlyPageName':'fNet Training Home Pg',
      'page.pageInfo.flowCode': 'fNet~TrainingPortal',
      'page.pageInfo.language':'EN',
      'page.pageInfo.lineOfBusiness':'Wireless',
      'page.pageInfo.responsiveWebDesignFlag': '1',
      'page.category.pageOwnership': 'Business',
      'page.pageInfo.appCode': 'fNet',
      'user.attributes.firstNetFlag': '1',
      'user.login.id': userStore.user.uid,
      'linkName': linkName,
      'linkPosition': 'Body',
      'contentFriendlyName': title,
      'linkDestinationUrl': linkDestinationUrl ? linkDestinationUrl : 'training.firstnet.att.com'
    }
    this.triggerCustomEvent('Adobe_Tag_Manager_Event', {
      evtAction: 'linkClick',
      evtName: 'Link_Click',
      params
    });
  }

  tagMediaItem(title, evtName) {

    let errorType = 'Success_Admit';
    let successFlag = 1;
    let statusCode = 0;
    if (evtName === 'Video_Error_Display') {
      errorType = 'Failure_Playback';
      successFlag = 0;
      statusCode = -1;
    }

    const params = {
      successFlag : successFlag,
      statusCode : statusCode,
      errorType : errorType,
      mediaFriendlyName : title
    }
    this.triggerCustomEvent('Adobe_Tag_Manager_Event', {
      evtAction: 'video',
      evtName: evtName,
      params
    });
  }

  getUrlParameter(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  handleError(err) {
    switch (err.response.status) {
      case 401:
        console.log('Received 401 Unauthenticated response, retrying user validation...');
        userStore.reauthenticateUser();
        break;
      case 403:
        console.log('Received 403 Forbidden response, redirecting to error page...');
        history.replace('/error');
        break;
      case 400:
        console.warn('Received 400 Gone response, redirecting to not available error page...');
        history.replace('/error/unavailable');
        break;
      case 500:
        console.log('Received 500 Internal Error response, redirecting to error page...');
        console.warn(err);
        history.replace('/error');
        break;
      default:
        console.log('Received ' + err.response.status + ' response, redirecting to error page...');
        console.warn(err);
        history.replace('/error');
        break;
    }
  }

  shouldFallBackToDownload() {
    const isInternetExplorer = Boolean(window.navigator && window.navigator.msSaveOrOpenBlob);
    const isSamsungBrowser = window.navigator.userAgent.match(/SamsungBrowser/i);
    return isInternetExplorer || isSamsungBrowser;
  }

  fetchFileAsBlob(fileName) {
    return this.fetchFile(fileName).then((response) => {
      const contentType = response.headers['content-type'];
      return this.saveFileAsBlob(response.data, contentType);
    });
  }

  fetchFile(fileName) {
    return apiService.getTrainingPortalFile(fileName);
  }

  saveFileAsBlob(file, contentType) {
    const byteArray = new Uint8Array(file);
    const blob = new Blob([byteArray], {
      type: contentType
    });
    const path = window.URL || window.webkitURL;
    const src = path.createObjectURL(blob);
    console.debug('Adding ' + src + ' (size: ' + blob.size/1000000 + ' MB, type: ' + blob.type + ')');
    console.debug('size: ' + blob.size/1000000 + ' MB, type: ' + blob.type);
    this.totalBlobSize += parseInt(blob.size);
    console.debug('Total Blob size is no greater than ' + this.totalBlobSize/1000000 + ' MB (some items have been removed)');
    return src;
  }

  clearFromBlob(src) {
    if(!this.shouldFallBackToDownload()) {
      const path = window.URL || window.webkitURL;
      console.debug('Removing ' + src);
      path.revokeObjectURL(src);
    }
  }

  downloadFile = (fileName, fileType, fileData) => {
    const byteArray = new Uint8Array(fileData);
    const blob = new Blob([byteArray], {
      type: fileType
    });
    saveAs(blob, fileName);
  }

  getFilename(str) {
    //takes a string and strips out directory information(eg: /path/filename.ext => filename.ext)
    return str.replace(/\s/g, '').replace(/^.*[\\/]/, '');
  }

  getFilePath(fileName) {
    if (!fileName) return '';
    return `${base}/training/content/${fileName}`;
    //return `https://localhost:4040/content/${fileName}`;
  }

  normalizedDate(date, displayFormat = 'MMMM D, YYYY') {
    if (!date) {
      return 'Missing Date';
    }
    //all dates come from services in Unix (epoch) time, which is in seconds. Use .valueOf() to convert to milliseconds for use in Moment and date-fns;
    const newDate = moment(Number(date))
    //check if the date is in a valid format, else return 'Bad Date Format'. this error message has been requested to assist QA in the app submission process;
    const dateToRender = newDate.isValid() ? newDate.format(displayFormat) : 'Bad Date Format';
    return dateToRender;
  }
}

export const utilsService = new UtilsService();
